import { Theme } from "./symbols";

export const darkTheme: Theme = {
    name: 'dark',
    properties: {
        '--background': '#1F2125',
        '--on-background': '#fff'
    }
}
